var _g, _mask, _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _path7, _circle, _circle2, _circle3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowToUse2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 236,
    viewBox: "0 0 356 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2524_98320)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 280,
    height: 160,
    rx: 10,
    fill: "white"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-outside-1_2524_98320",
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 32,
    width: 244,
    height: 126,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 55,
    y: 32,
    width: 244,
    height: 126
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 42C57 37.5817 60.5817 34 65 34H289C293.418 34 297 37.5817 297 42V148C297 152.418 293.418 156 289 156H65C60.5817 156 57 152.418 57 148V42Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 42C57 37.5817 60.5817 34 65 34H289C293.418 34 297 37.5817 297 42V148C297 152.418 293.418 156 289 156H65C60.5817 156 57 152.418 57 148V42Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 42C55.5 36.7533 59.7533 32.5 65 32.5H289C294.247 32.5 298.5 36.7533 298.5 42H295.5C295.5 38.4101 292.59 35.5 289 35.5H65C61.4101 35.5 58.5 38.4101 58.5 42H55.5ZM298.5 148C298.5 153.247 294.247 157.5 289 157.5H65C59.7533 157.5 55.5 153.247 55.5 148H58.5C58.5 151.59 61.4101 154.5 65 154.5H289C292.59 154.5 295.5 151.59 295.5 148H298.5ZM65 157.5C59.7533 157.5 55.5 153.247 55.5 148V42C55.5 36.7533 59.7533 32.5 65 32.5V35.5C61.4101 35.5 58.5 38.4101 58.5 42V148C58.5 151.59 61.4101 154.5 65 154.5V157.5ZM289 32.5C294.247 32.5 298.5 36.7533 298.5 42V148C298.5 153.247 294.247 157.5 289 157.5V154.5C292.59 154.5 295.5 151.59 295.5 148V42C295.5 38.4101 292.59 35.5 289 35.5V32.5Z",
    fill: "#53B1FD",
    mask: "url(#path-2-outside-1_2524_98320)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M142 147C142 146.448 142.448 146 143 146H208C208.552 146 209 146.448 209 147V155C209 155.552 208.552 156 208 156H143C142.448 156 142 155.552 142 155V147Z",
    fill: "#F3F4F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 147C70 146.448 70.4477 146 71 146H133C133.552 146 134 146.448 134 147V153C134 153.552 133.552 154 133 154H71C70.4477 154 70 153.552 70 153V147Z",
    fill: "#F9FAFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M217 147C217 146.448 217.448 146 218 146H283C283.552 146 284 146.448 284 147V155C284 155.552 283.552 156 283 156H218C217.448 156 217 155.552 217 155V147Z",
    fill: "#F3F4F6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63C70 61.8954 70.8954 61 72 61H132C133.105 61 134 61.8954 134 63V119C134 120.105 133.105 121 132 121H72C70.8954 121 70 120.105 70 119V63Z",
    fill: "#F3F4F6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 61,
    width: 142,
    height: 12,
    rx: 1,
    fill: "#F3F4F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 81,
    width: 131,
    height: 8,
    rx: 1,
    fill: "#F9FAFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 97,
    width: 97,
    height: 8,
    rx: 1,
    fill: "#F9FAFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 113,
    width: 82,
    height: 8,
    rx: 1,
    fill: "#F3F4F6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 142,
    y: 129,
    width: 97,
    height: 8,
    rx: 1,
    fill: "#F9FAFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57 42C57 37.5817 60.5817 34 65 34H289C293.418 34 297 37.5817 297 42V50H57V42Z",
    fill: "#E5E7EB"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 42,
    r: 4,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 42,
    r: 4,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 102,
    cy: 42,
    r: 4,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2524_98320",
    x: 0,
    y: 0,
    width: 356,
    height: 236,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2524_98320"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2524_98320"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2524_98320",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToUse2);
export default __webpack_public_path__ + "static/media/how_to_use_2.e79ad9cc4c092180b427179f83b2a17f.svg";
export { ForwardRef as ReactComponent };